import { MenuItemModel } from '../features/menu/types';

export const MenuItemsConfiguration: MenuItemModel[] = [
    new MenuItemModel('/newses', 'Novinky', 'fal fa-comment-alt-lines'),
    new MenuItemModel('/payrolltickets', 'Výplatní lístky', 'fal fa-file-invoice'),
    new MenuItemModel('/signout', 'Odhlásit', 'fal fa-power-off')
];
